import { PathEnum } from "./path.enum";

export namespace AppRouterService {
	const routes: { [key: string]: string } = {
		[PathEnum.start]: `/${PathEnum.start}`,
		[PathEnum.requirements]: `/${PathEnum.requirements}`,

		[PathEnum.step1]: `/${PathEnum.step1}`,
		[PathEnum.creazioneProfilo]: `/${PathEnum.step1}/${PathEnum.creazioneProfilo}`,
		[PathEnum.codiceAttivazione]: `/${PathEnum.step1}/${PathEnum.codiceAttivazione}`,
		[PathEnum.cercaImpresa]: `/${PathEnum.step1}/${PathEnum.cercaImpresa}`,

		[PathEnum.step2]: `/${PathEnum.step2}`,
		[PathEnum.presentaAzienda]: `/${PathEnum.step2}/${PathEnum.presentaAzienda}`,
		[PathEnum.datiAziendali]: `/${PathEnum.step2}/${PathEnum.datiAziendali}`,
		[PathEnum.indirizziContatti]: `/${PathEnum.step2}/${PathEnum.indirizziContatti}`,
		[PathEnum.bilancioImpresa]: `/${PathEnum.step2}/${PathEnum.bilancioImpresa}`,
		[PathEnum.dettagliSocieta]: `/${PathEnum.step2}/${PathEnum.dettagliSocieta}`,
		[PathEnum.step2Complete]: `/${PathEnum.step2}/${PathEnum.step2Complete}`,

		[PathEnum.step3]: `/${PathEnum.step3}`,
		[PathEnum.raccontaciDiTe]: `/${PathEnum.step3}/${PathEnum.raccontaciDiTe}`,
		[PathEnum.identificazioneLegaleRappresentante]: `/${PathEnum.step3}/${PathEnum.identificazioneLegaleRappresentante}`,
		[PathEnum.anagraficaLR]: `/${PathEnum.step3}/${PathEnum.identificazioneLegaleRappresentante}/${PathEnum.anagraficaLR}`,
		[PathEnum.ulterioriInformazioniLR]: `/${PathEnum.step3}/${PathEnum.identificazioneLegaleRappresentante}/${PathEnum.ulterioriInformazioniLR}`,
		[PathEnum.completeLR]: `/${PathEnum.step3}/${PathEnum.identificazioneLegaleRappresentante}/${PathEnum.completeLR}`,

		[PathEnum.sceltaTitolareEffettivo]: `/${PathEnum.step3}/${PathEnum.sceltaTitolareEffettivo}`,
		[PathEnum.identificazioneTitolareEffettivo]: `/${PathEnum.step3}/${PathEnum.identificazioneTitolareEffettivo}`,
		[PathEnum.anagraficaTE]: `/${PathEnum.step3}/${PathEnum.identificazioneTitolareEffettivo}/${PathEnum.anagraficaTE}`,
		[PathEnum.ulterioriInformazioniTE]: `/${PathEnum.step3}/${PathEnum.identificazioneTitolareEffettivo}/${PathEnum.ulterioriInformazioniTE}`,
		[PathEnum.verificaIdentitaTE]: `/${PathEnum.step3}/${PathEnum.identificazioneTitolareEffettivo}/${PathEnum.verificaIdentitaTE}`,
		[PathEnum.completeTE]: `/${PathEnum.step3}/${PathEnum.identificazioneTitolareEffettivo}/${PathEnum.completeTE}`,

		[PathEnum.step4]: `/${PathEnum.step4}`,
		[PathEnum.contoPagamento]: `/${PathEnum.step4}/${PathEnum.contoPagamento}`,
		[PathEnum.pos]: `/${PathEnum.step4}/${PathEnum.pos}`,
		[PathEnum.step4Complete]: `/${PathEnum.step4}/${PathEnum.step4Complete}`,

		[PathEnum.step5]: `/${PathEnum.step5}`,

		[PathEnum.step6]: `/${PathEnum.step6}`,

		[PathEnum.step7]: `/${PathEnum.step7}`,

		[PathEnum.processoTerminato]: `/${PathEnum.processoTerminato}`,

		[PathEnum.welcome]: `/${PathEnum.invitation}/${PathEnum.welcome}`,
		[PathEnum.identification]: `/${PathEnum.invitation}/${PathEnum.identification}`,
		[PathEnum.anagraficaInvitation]: `/${PathEnum.invitation}/${PathEnum.identification}/${PathEnum.anagraficaInvitation}`,
		[PathEnum.ulterioriInformazioniInvitation]: `/${PathEnum.invitation}/${PathEnum.identification}/${PathEnum.ulterioriInformazioniInvitation}`,
		[PathEnum.verificaIdentitaInvitation]: `/${PathEnum.invitation}/${PathEnum.identification}/${PathEnum.verificaIdentitaInvitation}`,
		[PathEnum.identificationComplete]: `/${PathEnum.invitation}/${PathEnum.identificationComplete}`,
		[PathEnum.invitationComplete]: `/${PathEnum.invitation}/${PathEnum.invitationComplete}`,

		[PathEnum.reopen]: `/${PathEnum.reopen}`,
		[PathEnum.reopenVerificaIdentitaLR]: `/${PathEnum.reopen}/${PathEnum.reopenVerificaIdentitaLR}`,
		[PathEnum.reopenVerificaIdentitaTE]: `/${PathEnum.reopen}/${PathEnum.reopenVerificaIdentitaTE}`,
		[PathEnum.reopenDocumentiAziendali]: `/${PathEnum.reopen}/${PathEnum.reopenDocumentiAziendali}`,
		[PathEnum.reopenDocumentiPagamenti]: `/${PathEnum.reopen}/${PathEnum.reopenDocumentiPagamenti}`,
		[PathEnum.reopenIdentificazione]: `/${PathEnum.reopen}/${PathEnum.reopenIdentificazione}`,
		[PathEnum.reopenFirma]: `/${PathEnum.reopen}/${PathEnum.reopenFirma}`,
		[PathEnum.reopenProcessoTerminato]: `/${PathEnum.reopen}/${PathEnum.reopenProcessoTerminato}`,
	};

	export const get = (key: PathEnum) => {
		let route = routes[key];

		if (!route) throw "No route found: " + key;

		return route;
	};
}
